import React, { PureComponent } from "react";
import styled from "styled-components";
import Emoji from "../Emoji/Emoji";
import { colors } from "../../theme";

const ForOFourContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 555;
  background-color: ${colors.red};
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  color: white;
`;

class ForOFourView extends PureComponent {
  render() {
    return (
      <ForOFourContainer>
        <div>
          <h1>
            Pagina niet gevonden <Emoji>:frowning:</Emoji>
          </h1>
        </div>
      </ForOFourContainer>
    );
  }
}

export default ForOFourView;



// WEBPACK FOOTER //
// ./src/components/FourOFour/index.js